module.exports = "/images/uy.svg?668b6c5c3f33120db33a142df7d5f2c1";